import styled from 'styled-components';
import { text, fontFamilyBold } from '../../../styling/mixins/typography';
import { getColor } from '../../../styling/mixins/colors';
import Dropdown from '../../Dropdown';

export const StyledRegister = styled.div`
  h1 {
    ${fontFamilyBold};
    margin-bottom: 8px;
    text-transform: uppercase;
  }

  p {
    ${text('large')}
  }

  h4 {
    ${fontFamilyBold};
    font-size: 2.025rem;
    text-transform: uppercase;
    margin-top: 2.4rem;
    margin-bottom: 1.6rem;
  }

  .form {
    margin-top: 2.4rem;
  }

  .input__wrapper {
    margin-bottom: 1.6rem;

    &:nth-child(2) {
    margin-bottom: 1.2rem;
    }
  }

  .submit {
    margin-top: 1.2rem;
  }

  .additional {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    margin-top: 1.6rem;

    &__btn {
      text-decoration: underline;
    }
  }

  .news-checkbox {
    ${text('large')}
    margin-bottom: 1.2rem;    

    div {
      height: 23px;
    }
  }

  .country-select-container {
    display: flex;    
    flex-direction: column;

    .country-label {
      ${text('large')}
      ${fontFamilyBold}
      margin-bottom: 0.8rem;
    }
  }
`;

export const StyledCheckoutDropdown = styled(Dropdown)`
  margin-bottom: 1.6rem;

  .dropdown-select {
    background-color: ${getColor('white')};
    padding-top: 1.2rem;
    padding-bottom: 1.2rem;
  }
`;